<template>
  <div class="page_invoicing">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs" v-if="activeName!='6'">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
            <el-form-item label="归属项目:">
              <el-select v-model="listQuery.projectid" size="small" filterable clearable placeholder="" style="width: 180px;">
                <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="归属月:">
              <el-date-picker v-model="listQuery.ownershipMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="主体:">
              <el-select v-model="listQuery.subjectOfLegalAffairsId" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in legList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen==-1 && activeName!='6'" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
      </div>
    </div>
    <!-- <el-collapse-transition> -->
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
          <el-form-item label="发票号码:" v-if="(activeName=='4'&& activeName2=='2') || (activeName=='5'&& activeName2=='3')">
            <el-input v-model="listQuery.invoiceNumber" size="small" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="归属部门:">
            <el-cascader v-model="dedpartNameList" size="small" :props="props" clearable filterable :options="departList" placeholder="" @change="departChange" style="width: 180px;"></el-cascader>
          </el-form-item>
          <!-- <el-form-item label="客户名称:">
            <el-input v-model="listQuery.strUserName" size="small" clearable></el-input>
          </el-form-item> -->
          <el-form-item label="客户名称:">
            <el-select v-model="listQuery.custid" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
              <el-option v-for="(item, index) in custList" :key="index" :label="item.StrCustName" :value="item.Custid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务员:">
            <el-select v-model="listQuery.strpartner2" size="small" filterable clearable placeholder="" style="width: 180px;">
              <el-option v-for="(item, index) in memberList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合伙人:">
            <el-select v-model="listQuery.strAchieveowner" size="small" filterable clearable placeholder="" style="width: 180px;">
              <el-option v-for="(item, index) in memberList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客服:">
            <el-select v-model="listQuery.strservuserid" size="small" filterable clearable placeholder="" style="width: 180px;">
              <el-option v-for="(item, index) in memberList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="归属部门:">
            <el-cascader v-model="dedpartNameList" size="small" :props="props" clearable filterable :options="departList" placeholder="" @change="departChange2" style="width: 180px;"></el-cascader>
          </el-form-item>
          <el-form-item label="创建时间:">
            <el-date-picker v-model="listQuery.start" value-format="yyyy-MM-dd" type="date" size="small" placeholder="开始日期" class="r_line_input1" style="width: 180px;"></el-date-picker>
          </el-form-item>
          <el-form-item label="创建时间:">
            <el-date-picker v-model="listQuery.end" value-format="yyyy-MM-dd" type="date" size="small" placeholder="结束日期" class="r_line_input2" style="width: 180px;"></el-date-picker>
          </el-form-item>
          <el-form-item label="申请人:" v-if="activeName!='0'">
            <el-select v-model="listQuery.applicant" size="small" filterable clearable placeholder="" style="width: 180px;">
              <el-option v-for="(item, index) in memberList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票人:" v-if="activeName=='4'">
            <el-select v-model="listQuery.drawer" size="small" filterable clearable placeholder="" style="width: 180px;">
              <el-option v-for="(item, index) in memberList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票方式:" v-if="activeName!='0'">
            <el-select v-model="listQuery.billingMethod" size="small" filterable clearable placeholder="" style="width: 180px;">
              <el-option label="全部" :value="0">
              </el-option>
              <el-option label="全额" :value="1">
              </el-option>
              <el-option label="差额" :value="2">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <!-- <el-button size="small" plain @click="resetHandle">清空</el-button> -->
        <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
        <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageTitle}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- v-if="checkPermission(['publicResources_page_list'],permissionLists)" -->
      <div class="ftabs">
        <div class="tabsColor">
          <el-tabs v-model="activeName" type="card" @tab-click="changeTab" class="s_tabs_box">
            <el-tab-pane :disabled="loading" label="费用结算单" name="0" v-if="checkPermission(['settlement'], permissionLists)"></el-tab-pane>
            <el-tab-pane :disabled="loading" label="开票申请" name="1" v-if="checkPermission(['invoiceApp'], permissionLists)"></el-tab-pane>
            <el-tab-pane :disabled="loading" label="发票待办" name="2" v-if="checkPermission(['invoicePending'], permissionLists)"></el-tab-pane>
            <el-tab-pane :disabled="loading" label="部分开票" name="3" v-if="checkPermission(['invoicePartial'], permissionLists)"></el-tab-pane>
            <el-tab-pane :disabled="loading" label="已开票" name="4" v-if="checkPermission(['invoiced'], permissionLists)"></el-tab-pane>
            <el-tab-pane :disabled="loading" label="废票/红冲记录" name="5" v-if="checkPermission(['delList'], permissionLists)"></el-tab-pane>
            <el-tab-pane :disabled="loading" label="全量查询" name="6" v-if="checkPermission(['FullDose_Query'], permissionLists)"></el-tab-pane>
          </el-tabs>
        </div>
        <!-- 发票申请模块内容 -->
        <div class="info_tab_box" v-if="activeName=='1'">
          <el-tabs v-model="activeName2" @tab-click="changeTab2" class="s_tabs_box">
            <el-tab-pane label="全部" name="0"></el-tab-pane>
            <el-tab-pane label="退回" name="1"></el-tab-pane>
          </el-tabs>
        </div>
        <!-- 除去已开票、废票/红冲记录模块内容 -->
        <div class="r_act_box" v-if="activeName!='4'&&activeName!='5'">
          <div class="r_act_left">
            <div class="dec_box" v-if="activeName=='0'">
              <p class="dec_txt">
                <span class="txt01">结算单份数：</span>
                <span class="txt02">{{totalCount}}</span>
              </p>
              <p class="dec_txt" v-if="argument!=null">
                <span class="txt01">合计金额：</span>
                <span class="txt02">{{argument.sumAmount}}元</span>
              </p>
            </div>
            <div class="dec_box" v-if="activeName=='1'">
              <p class="dec_txt">
                <span class="txt01">笔数：</span>
                <span class="txt02">{{totalCount}}</span>
              </p>
              <p class="dec_txt" v-if="argument!=null">
                <span class="txt01">合计金额：</span>
                <span class="txt02">{{argument.sumAmount}}元</span>
              </p>
            </div>
            <div class="dec_box" v-if="activeName=='2'">
              <p class="dec_txt">
                <span class="txt01">待开笔数：</span>
                <span class="txt02">{{totalCount}}</span>
              </p>
              <p class="dec_txt" v-if="argument!=null">
                <span class="txt01">待开合计金额：</span>
                <span class="txt02">{{argument.sumAmountBilled!=undefined && argument.sumAmountBilled ? argument.sumAmountBilled : 0}}元</span>
              </p>
            </div>
            <div class="dec_box" v-if="activeName=='3'">
              <p class="dec_txt">
                <span class="txt01">批数：</span>
                <span class="txt02">{{numQuery.num1}}</span>
              </p>
              <p class="dec_txt">
                <span class="txt01">已开金额：</span>
                <span class="txt02">{{numQuery.price1}}元</span>
              </p>
              <p class="dec_txt">
                <span class="txt01">待开金额：</span>
                <span class="txt02">{{numQuery.price2}}元</span>
              </p>
            </div>
          </div>
          <div class="r_act_right">
            <div class="r_act_item" v-if="activeName=='0'">
              <el-button size="small" type="primary" @click="statementHandle">上传结算单</el-button>
            </div>
            <div class="r_act_item" v-if="activeName=='0' || activeName=='1'">
              <el-button size="small" type="success" @click="applyHandle" v-if="checkPermission(['invoiceApp_app'], permissionLists)">申请开票</el-button>
              <el-button size="small" type="warning" @click="batchImportInv" v-if="checkPermission(['invoiceApp_app'], permissionLists)">批量导入开票</el-button>
              <el-popconfirm :title="'请确认是否作废选中的 ' + multipleSelection.length + ' 条申请？'" @confirm="batchDel()" style="margin-left:10px;" v-if="checkPermission(['invoiceApp_del'], permissionLists)">
                <el-button size="small" type="danger" slot="reference">批量作废</el-button>
              </el-popconfirm>
            </div>
            <div class="r_act_item" v-if="activeName=='2'">
              <el-button size="small" type="primary" @click="mulInvoiceHandle" v-if="checkPermission(['invoicePending_invoicing1'], permissionLists)">开票</el-button>
              <el-button size="small" type="warning" @click="noAppInvoiceHandle" v-if="checkPermission(['invoicePending_invoicing'], permissionLists)">无申请开票</el-button>
            </div>
            <div class="r_act_item" v-if="activeName=='2'">
              <el-button size="small" type="danger" @click="batchBack" v-if="checkPermission(['invoicePending_return'], permissionLists)">批量退回</el-button>
              <el-button size="small" type="primary" @click="registHandle" v-if="checkPermission(['invoicePending_registe'], permissionLists)">登记线下开票</el-button>
            </div>
            <div class="r_act_item" v-if="(tableData.length > 0)&&(checkPermission(['publicResources_export'],permissionLists))">
              <el-button size="small" class="com_btn" @click="exportHandle" :loading="btnLoading">导出</el-button>
            </div>
          </div>
        </div>
        <!-- 已开票、废票/红冲记录模块内容 -->
        <div class="info_box" v-if="activeName=='4'||activeName=='5'">
          <el-tabs v-model="activeName2" @tab-click="changeTab2" class="s_tabs_box">
            <el-tab-pane label="按张（可下载发票）" name="2" v-if="activeName=='4'"></el-tab-pane>
            <el-tab-pane label="按张（可下载发票）" name="3" v-if="activeName=='5'"></el-tab-pane>
            <el-tab-pane :label="activeName=='4'?'按申请笔次':'按笔次'" name="0"></el-tab-pane>
          </el-tabs>
          <div class="info_item" v-for="(item,index) in decInfoList" :key="index">
            <p class="dec_txt" v-if="item.num1">
              <span class="txt03">{{item.name}}：</span>
              <span class="txt03">{{item.num1}}</span>
            </p>
            <p class="dec_txt" v-if="item.num2">
              <span class="txt03">其中专票：</span>
              <span class="txt03">{{item.num2}}</span>
            </p>
            <p class="dec_txt" v-if="item.num3">
              <span class="txt03">普票：</span>
              <span class="txt03">{{item.num3}}</span>
            </p>
            <p class="dec_txt" v-if="item.num4">
              <span class="txt03">全额：</span>
              <span class="txt03">{{item.num4}}</span>
            </p>
            <p class="dec_txt" v-if="item.num5">
              <span class="txt03">差额：</span>
              <span class="txt03">{{item.num5}}</span>
            </p>
            <p class="dec_txt" v-if="item.num6">
              <span class="txt03">废票/红冲记录金额：</span>
              <span class="txt03">{{item.num6}}</span>
            </p>
          </div>
          <div class="r_act_right">
            <div class="r_act_item" v-if="activeName=='4'">
              <el-button size="small" type="warning" @click="batchDown">批量下载发票</el-button>
              <el-button size="small" type="success" @click="loginHandel">登录主体</el-button>
              <el-button size="small" type="primary" @click="expList" :loading="isExping">导出</el-button>
            </div>
          </div>
        </div>
        <!-- <div class="tips" v-if="activeName=='0'">点击“+”即可展开</div> -->
        <!-- :tree-props="{children: 'children', hasChildren: 'hasChildren'}" -->
        <el-table :data="tableData" ref="elTable" v-if="activeName=='0'" v-loading="loading" style="width: 100%" :row-key="(row) => { return row.finalStatementId }" border class="doc_table">
          <el-table-column type="expand" key="expand" width="1" :resizable="false">
            <template slot-scope="scopes">
              <div class="expandTable">
                <el-table :data="scopes.row.details">
                  <el-table-column align="center" prop="ownershipName" label="项目" fit :show-overflow-tooltip="true" min-width="140">
                  </el-table-column>
                  <el-table-column align="center" prop="ownershipMonth" label="归属月" fit :show-overflow-tooltip="true" min-width="100">
                  </el-table-column>
                  <el-table-column align="center" prop="subjectOfLegalAffairsName" label="法务实体" fit :show-overflow-tooltip="true" min-width="160">
                  </el-table-column>
                  <el-table-column align="center" prop="settleAccountAmount" label="结算金额" fit :show-overflow-tooltip="true" min-width="100">
                  </el-table-column>
                  <el-table-column align="center" prop="invoiceAmount" label="已开票金额" min-width="120px" fit :show-overflow-tooltip="true">
                  </el-table-column>
                  <el-table-column align="center" prop="finalStatementNo" label="结算单编号" min-width="120px" fit :show-overflow-tooltip="true">
                  </el-table-column>
                  <el-table-column align="center" prop="partner" label="合伙人" fit :show-overflow-tooltip="true" min-width="100">
                  </el-table-column>
                  <el-table-column align="center" prop="salesman" label="业务员" fit :show-overflow-tooltip="true">
                  </el-table-column>
                  <el-table-column align="center" prop="serviceDepartment" label="服务部门" fit :show-overflow-tooltip="true" min-width="100">
                  </el-table-column>
                  <el-table-column align="center" prop="customerService" label="客服" fit :show-overflow-tooltip="true" min-width="100">
                  </el-table-column>
                  <el-table-column align="center" prop="name" label="创建人" fit :show-overflow-tooltip="true" min-width="100">
                  </el-table-column>
                  <el-table-column align="center" prop="createTime" label="创建时间" fit :show-overflow-tooltip="true" min-width="100">
                  </el-table-column>
                  <el-table-column align="center" prop="name" label="备注" fit :show-overflow-tooltip="true" min-width="100">
                  </el-table-column>
                  <el-table-column align="center" prop="fileUrl" label="附件" fit :show-overflow-tooltip="true" min-width="100">
                    <!-- <template slot-scope="{row}">
                      <span>{{ row.num }}</span>
                    </template> -->
                  </el-table-column>
                  <el-table-column align="center" label="操作" fixed="right" min-width="200px">
                    <template slot-scope="{row}">
                      <div class="injuryTabBtn">
                        <el-button v-if="activeName2 == '0'" type="text" size="small" @click="dtlSettleHandle(row)">查看</el-button>
                        <el-button v-if="activeName2 == '1'" type="text" size="small" @click="DtlHandle(row)">查看</el-button>
                        <el-button type="text" size="small" @click="modifyHandle(row)" v-if="checkPermission(['settlement_edit'], permissionLists)">修改</el-button>

                        <el-popconfirm title="请确认是否作废" @confirm="voidHandle(row)" style="margin-left:10px;" v-if="checkPermission(['settlement_del'], permissionLists)">
                          <el-button type="text" v-preventReClick slot="reference">作废</el-button>
                        </el-popconfirm>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column width="40" :resizable="false">
            <template v-slot="scope">
              <div class="align-items-center">
                <div class="cp" @click="handleExpandChange">
                  <div v-if="!scope.row.isExpand"> <i class="el-icon-plus icon"></i></div>
                  <div v-else> <i class="el-icon-minus icon"></i></div>
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column align="center" min-width="100" label="项目/部门" prop="ownershipName" fit :show-overflow-tooltip="true" fixed="left"></el-table-column>
          <el-table-column align="center" min-width="100" label="归属月" prop="ownershipMonth" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" min-width="160" label="客户名称" prop="strCustName" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" min-width="140" label="结算单金额小计" prop="amount"></el-table-column>
          <el-table-column align="center" min-width="140" label="已开票金额小计" prop="invoiceAmount"></el-table-column>
          <el-table-column align="center" min-width="100" label="待开票金额" prop="outstandingAmount"></el-table-column>
          <el-table-column align="center" min-width="140" label="已到款金额小计" prop="receivePaymentAmountSum"></el-table-column>
          <el-table-column align="center" min-width="140" label="应收账款小计" prop="receivableAmountSum"></el-table-column>
          <el-table-column align="center" min-width="140" label="已发薪金额小计" prop="payrollPaymentAmountSum"></el-table-column>
          <el-table-column align="center" min-width="100" prop="partner" label="合伙人" fit :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column align="center" min-width="100" prop="salesman" label="业务员" fit :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column align="center" prop="customerService" label="客服" fit :show-overflow-tooltip="true" min-width="100">
          </el-table-column>
          <el-table-column align="center" prop="founder" label="创建人" fit :show-overflow-tooltip="true" min-width="100">
          </el-table-column>
          <el-table-column align="center" prop="createTime" label="创建时间" fit :show-overflow-tooltip="true" min-width="140">
            <template slot-scope="{row}">{{ row.createTime ? row.createTime.replace('T',' ') : '' }}</template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="备注" fit :show-overflow-tooltip="true" min-width="100">
          </el-table-column>
          <el-table-column align="center" prop="fileUrl" label="附件" fit :show-overflow-tooltip="true" min-width="200">
            <template slot-scope="{row}">
              <div class="blueName cp" v-for="(item,index) in row.fileUrl" :key="index" @click="down(item.fileUrl)">{{ item.fileName }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right" min-width="160px">
            <template slot-scope="{row}">
              <div class="injuryTabBtn">
                <el-button v-if="activeName2 == '0'" type="text" size="small" @click="dtlSettleHandle(row)">查看</el-button>
                <el-button v-if="activeName2 == '1'" type="text" size="small" @click="DtlHandle(row)">查看</el-button>
                <el-button type="text" size="small" @click="modifyHandle(row)" v-if="checkPermission(['settlement_edit'], permissionLists)">修改</el-button>
                <el-button type="text" v-preventReClick @click="voidHandle(row)" v-if="checkPermission(['settlement_del'], permissionLists)">作废</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-table v-else-if="activeName!='6'" ref="multipleTable" class="doc_table" v-loading="loading" @selection-change="handleSelectionChange" border :max-height="tableHeight-100" :data="tableData" style="width:100%">
          <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column>
          <el-table-column align="center" key="1" label="开票编号" prop="invoiceNo" fit :show-overflow-tooltip="true" fixed="left" min-width="100" v-if="activeName=='4'"></el-table-column>
          <el-table-column align="center" key="2" label="申请编号" prop="invoiceNo" fit :show-overflow-tooltip="true" min-width="100"></el-table-column>
          <el-table-column align="center" key="2.5" label="发票号码" prop="invoiceNumber" fit :show-overflow-tooltip="true" min-width="170" v-if="(activeName=='4' && activeName2 == '2') || (activeName=='5'&& activeName2=='3')"></el-table-column>
          <el-table-column align="center" key="3" label="法务实体" prop="strLegalsubName" fit :show-overflow-tooltip="true" min-width="180"></el-table-column>
          <el-table-column align="center" key="4" label="项目/部门" prop="ownershipName" fit :show-overflow-tooltip="true" min-width="140"></el-table-column>
          <el-table-column align="center" key="5" label="客户名称" prop="strCustName" fit :show-overflow-tooltip="true" min-width="160" v-if="activeName!='4' && 
          activeName!='5'"></el-table-column>
          <el-table-column align="center" prop="invoiceTitle" label="发票抬头" fit :show-overflow-tooltip="true" min-width="160" v-if="activeName=='2' || activeName=='3' || activeName=='4'">
          </el-table-column>
          <el-table-column align="center" key="6" label="状态" prop="status" fit :show-overflow-tooltip="true" min-width="100"></el-table-column>
          <el-table-column align="center" key="7" label="开票金额" :prop="activeName=='5' && activeName2=='3' ? 'invoiceAmount' : 'amount'" fit :show-overflow-tooltip="true" min-width="120"></el-table-column>
          <!-- <el-table-column align="center" key="8" label="服务费" prop="invoicedAmount" fit :show-overflow-tooltip="true" min-width="100" v-if="activeName=='4'"></el-table-column>
          <el-table-column align="center" key="8.1" label="工资" prop="invoicedAmount" fit :show-overflow-tooltip="true" min-width="100" v-if="activeName=='4'"></el-table-column>
          <el-table-column align="center" key="8.2" label="社保公积金" prop="invoicedAmount" fit :show-overflow-tooltip="true" min-width="100" v-if="activeName=='4'"></el-table-column> -->
          <el-table-column align="center" key="9" label="税率" prop="taxRate" fit :show-overflow-tooltip="true" min-width="120" v-if="activeName=='4'"></el-table-column>
          <el-table-column align="center" key="10" label="税额" prop="taxPayableAmount" fit :show-overflow-tooltip="true" min-width="120" v-if="activeName=='4'"></el-table-column>
          <el-table-column align="center" key="11" label="发票类型" :prop="activeName=='4' || activeName=='5' ? 'type' : 'ticketTypeName'" fit :show-overflow-tooltip="true" min-width="100"></el-table-column>
          <el-table-column align="center" key="12" label="开票方式" prop="billingMethod" fit :show-overflow-tooltip="true" min-width="100"></el-table-column>
          <el-table-column align="center" key="13" label="票种" prop="ticketType" :show-overflow-tooltip="true" min-width="100" v-if="activeName=='4'"></el-table-column>
          <el-table-column align="center" key="14" label="开票内容" prop="invoicingName" :show-overflow-tooltip="true" min-width="100" v-if="activeName=='4'"></el-table-column>
          <el-table-column align="center" key="15" label="开票渠道" prop="isOffline" :show-overflow-tooltip="true" min-width="100" v-if="activeName=='4' || activeName=='5'"></el-table-column>
          <el-table-column align="center" key="16" label="申请备注" prop="remark" fit :show-overflow-tooltip="true" min-width="100"></el-table-column>
          <el-table-column align="center" key="17" label="其他备注" prop="" fit :show-overflow-tooltip="true" min-width="100"></el-table-column>
          <el-table-column align="center" key="18" label="业务员" prop="salesman" fit :show-overflow-tooltip="true" min-width="100"></el-table-column>
          <el-table-column align="center" key="19" label="合伙人" prop="partner" fit :show-overflow-tooltip="true" min-width="100"></el-table-column>
          <el-table-column align="center" key="20" label="客服" prop="customerService" fit :show-overflow-tooltip="true" min-width="100"></el-table-column>
          <el-table-column align="center" key="21" label="服务部门" prop="serviceDepartment" fit :show-overflow-tooltip="true" min-width="100"></el-table-column>
          <el-table-column align="center" key="22" label="申请人" prop="applicant" fit :show-overflow-tooltip="true" min-width="100"></el-table-column>
          <el-table-column align="center" key="23" label="申请时间" prop="applicationTime" fit :show-overflow-tooltip="true" min-width="160">
            <template slot-scope="{row}">{{row.applicationTime ? row.applicationTime.replace('T',' ') : ''}}</template>
          </el-table-column>
          <el-table-column align="center" key="24" prop="returnInstructions" label="退回备注" fit :show-overflow-tooltip="true" min-width="100" v-if="activeName=='1' && activeName2=='1'">
          </el-table-column>
          <el-table-column align="center" key="25" prop="returnTime" label="退回时间" fit :show-overflow-tooltip="true" min-width="160" v-if="activeName=='1' && activeName2=='1'">
            <template slot-scope="{row}">{{row.returnTime ? row.returnTime.replace('T',' ') : ''}}</template>
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right" :width="activeName=='1' ?'200px': activeName=='4' ? '260px' : '140px'" class-name="re_act_box">
            <template slot-scope="{row}">
              <div class="injuryTabBtn">
                <div v-if="activeName=='1'">
                  <el-button type="text" size="small" @click="DtlHandle(row)">查看</el-button>
                  <el-button v-if="activeName2=='0' && checkPermission(['invoiceApp_edit'], permissionLists)" type="text" size="small" plai @click="editHandle(row)">编辑</el-button>
                  <el-button v-if="activeName2=='0' && checkPermission(['invoiceApp_submit'], permissionLists)" type="text" size="small" @click="submitHandle(row)">提交申请</el-button>
                  <el-button v-if="activeName2=='1' && checkPermission(['invoiceApp_edit'], permissionLists)" type="text" size="small" @click="editHandle(row)">编辑提交</el-button>
                  <el-popconfirm title="请确认是否作废" @confirm="delInv(row)" style="margin-left:10px;" v-if="checkPermission(['invoiceApp_del'], permissionLists)">
                    <el-button type="text" v-preventReClick slot="reference">作废</el-button>
                  </el-popconfirm>
                </div>
                <div v-if="activeName=='2'">
                  <el-button type="text" @click="DtlHandle(row)">查看</el-button>
                  <el-button type="text" @click="singleInvoiceHandle(row)" v-if="checkPermission(['invoicePending_invoicing'], permissionLists)">开票</el-button>
                  <el-button type="text" @click="handelBack(row)" v-if="checkPermission(['invoicePending_return'], permissionLists)">退回</el-button>
                </div>
                <div v-if="activeName=='3'">
                  <el-button type="text" size="small" @click="DtlHandle(row)">查看</el-button>
                </div>
                <div v-if="activeName=='4'">
                  <el-button type="text" size="small" @click="followHandle(row,row.invoiceId,1,'view')" v-if="activeName2=='0'">查看</el-button>
                  <el-button type="text" size="small" @click="followHandle(row,row.actualBillingBasicId,2,'view')" v-else>查看</el-button>
                  <!-- <el-button v-if="activeName2=='0'" type="text" size="small" @click="followHandle(row)">整笔作废</el-button>
                  <el-button v-if="activeName2=='1'" type="text" size="small" @click="voidHandle(row)">作废</el-button> -->
                  <el-button v-if="activeName2=='0' && checkPermission(['invoiced_redChong'], permissionLists)" type="text" size="small" @click="followHandle(row,row.invoiceId,1,'')">整笔红冲</el-button>
                  <el-button v-if="activeName2=='0' && checkPermission(['invoiced_redChong'], permissionLists)" type="text" size="small" @click="followHandle(row,row.invoiceId,1,'handel')">手工登记红冲</el-button>
                  <el-button v-if="activeName2=='2'" type="text" size="small" @click="downRowInvoice(row)">下载发票</el-button>
                  <el-button v-if="activeName2=='2' && checkPermission(['invoiced_redChong'], permissionLists)" type="text" size="small" @click="followHandle(row,row.actualBillingBasicId,2,'')">红冲</el-button>
                  <el-button v-if="activeName2=='2' && checkPermission(['invoiced_redChong'], permissionLists)" type="text" size="small" @click="followHandle(row,row.actualBillingBasicId,2,'handel')">手工登记红冲</el-button>
                </div>
                <div v-if="activeName=='5'">
                  <el-button type="text" size="small" @click="followHandle(row,row.invoiceId,1,'')" v-if="activeName2=='0'">查看</el-button>
                  <el-button type="text" size="small" @click="followHandle(row,row.actualBillingBasicId,2,'view')" v-else>查看</el-button>
                  <el-button v-if="activeName2=='0' && checkPermission(['delList_remake'], permissionLists)" type="text" size="small" @click="editHandle(row)">申请重开</el-button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="activeName!='6'">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="listQuery.pagination.page" :page-size="listQuery.pagination.pageSize" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager,next,jumper" :total="totalCount"></el-pagination>
        </div>

        <div v-if="activeName=='6'" class="allQuery">
          <el-form label-width="120px" :model="allQuery" ref="allQuery" :inline="true" :rules="allRules">
            <el-form-item label="主体:" prop="subjectOfLegalAffairs">
              <el-select v-model="allQuery.subjectOfLegalAffairs" placeholder="" size="small" style="width: 180px;" clearable filterable @change="changeSub">
                <el-option v-for="(item, index) in legList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开票起始时间:" prop="kprqq">
              <el-date-picker v-model="allQuery.kprqq" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="开票结束时间:" prop="kprqz">
              <el-date-picker v-model="allQuery.kprqz" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="发票号码:">
              <el-input v-model="allQuery.fphm" size="small" style="width: 180px;"></el-input>
            </el-form-item>
            <el-form-item label="查询类型:">
              <el-select v-model="allQuery.cxlx" placeholder="" value-key="Projectid" size="small" style="width: 180px;">
                <el-option label="开具发票" :value="1"></el-option>
                <el-option label="取得发票" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-button type="success" size="small" @click="allSearch" style="margin-left:15px;margin-top: 4px">全量查询</el-button>
          </el-form>

          <el-table class="doc_table" v-loading="loading" border :max-height="tableHeight-200" :data="allData" style="width:99%">
            <el-table-column label="购买方名称" prop="gmfmc" :show-overflow-tooltip="true" align="center" min-width="160">
            </el-table-column>
            <el-table-column label="购买方纳税人识别号" prop="gmfnsrsbh" :show-overflow-tooltip="true" align="center" min-width="160">
            </el-table-column>
            <el-table-column label="销售方名称" prop="xsfmc" :show-overflow-tooltip="true" align="center" min-width="160">
            </el-table-column>
            <el-table-column label="销售方纳税人识别号" prop="xsfnsrsbh" :show-overflow-tooltip="true" align="center" min-width="160">
            </el-table-column>
            <el-table-column label="发票号码" prop="fphm" :show-overflow-tooltip="true" align="center" min-width="160">
            </el-table-column>
            <el-table-column label="发票状态" prop="fppzDm" :show-overflow-tooltip="true" align="center" min-width="100">
              <template slot-scope="{row}">
                <span v-if="row.fppzDm">
                  {{ row.fppzDm == '01' ? '正常' : row.fppzDm == '02' ? '已作废' : row.fppzDm == '03' ? '已红冲-全额' : '已红冲-部分' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="合计金额" prop="hjje" :show-overflow-tooltip="true" align="center" min-width="100">
            </el-table-column>
            <el-table-column label="合计税额" prop="hjse" :show-overflow-tooltip="true" align="center" min-width="100">
            </el-table-column>
            <el-table-column label="价税合计" prop="jshj" :show-overflow-tooltip="true" align="center" min-width="100">
            </el-table-column>
            <el-table-column label="开票日期" prop="kprq" :show-overflow-tooltip="true" align="center" min-width="160">
            </el-table-column>
            <el-table-column label="开票人" prop="kpr" :show-overflow-tooltip="true" align="center" min-width="100">
            </el-table-column>
            <!-- <el-table-column label="发票类型" prop="kpr" :show-overflow-tooltip="true" align="center" min-width="100">
              <template slot-scope="{row}">
                <span v-if="row.fppzDm">
                  {{ row.fppzDm == '01' ? '正常' : row.fppzDm == '02' ? '已作废' : row.fppzDm == '03' ? '已红冲-全额' : '已红冲-部分' }}
                </span>
              </template>
            </el-table-column> -->
          </el-table>
          <div class="block">
            <el-pagination @current-change="handleCurrentChange2" :current-page.sync="allQuery.pageNo" :page-size="allQuery.pageSize" @size-change="handleSizeChange2" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager,next,jumper" :total="allTotal"></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 上传/修改结算单弹框 -->
    <el-dialog :title="stateTitle" :visible.sync="statementVisible" width="640px" class="res_dialog enter_dialog">
      <p class="note_txt">注：不属于项目的结算单才选择部门</p>
      <el-form :rules="statementRules" ref="statementForm" :model="statementQuery" class="re_down_form" label-width="100px">
        <el-form-item label="归属:" prop="type">
          <div class="i_radio_box">
            <el-radio-group v-model="statementQuery.type">
              <el-radio :label="1">项目</el-radio>
              <el-radio :label="2">内部部门</el-radio>
            </el-radio-group>
            <div class="i_box">
              <el-select v-model="statementQuery.ownershipId" v-if="statementQuery.type == 1" placeholder="请选择项目" size="small" filterable clearable>
                <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
              <el-cascader v-if="statementQuery.type == 2" ref="cascaderDep" v-model="dedpartDiaVal" size="small" :props="props" clearable filterable :options="departList" placeholder="请选择部门" @change="departDiaChange"></el-cascader>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="归属月:" prop="ownershipMonth">
          <el-date-picker v-model="statementQuery.ownershipMonth" value-format="yyyy-MM" type="month" size="small" placeholder=""></el-date-picker>
        </el-form-item>
        <el-form-item label="结算单金额:" prop="amount">
          <el-input v-model="statementQuery.amount" size="small" type="number" clearable style="width:220px"></el-input>
        </el-form-item>
        <el-form-item label="结算单备注:" prop="remark">
          <el-input v-model="statementQuery.remark" size="small" type="textarea" rows="4" clearable></el-input>
        </el-form-item>
        <el-form-item label="附件:" prop="files">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="5" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="stateFileList">
            <el-button size="small" type="primary">上传结算单附件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="statementVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="saveStatementHandle" size="small">确定</el-button>
      </span>
    </el-dialog>
    <!-- 确认作废/不能作废弹框 -->
    <el-dialog title="确认作废" :visible.sync="voidVisible" width="460px" class="res_dialog void_dialog">
      <el-form ref="voidForm" :model="voidQuery" label-width="80px">
        <el-form-item label="项目/部门:">
          <span>{{statementQuery.ownershipName}}</span>
        </el-form-item>
        <el-form-item label="归属月:">
          <span>{{statementQuery.ownershipMonth}}</span>
        </el-form-item>
        <el-form-item label="金额:">
          <span>￥{{statementQuery.amount}}</span>
        </el-form-item>
        <el-form-item label="创建时间:">
          <span>{{statementQuery.createTime ? statementQuery.createTime.replace('T',' ') : ''}}</span>
        </el-form-item>
        <el-form-item label="创建人:">
          <span>{{statementQuery.founder}}</span>
        </el-form-item>
      </el-form>
      <p class="n_txt" v-if="!statementQuery.invoiceHasBeenIssued">此结算单未开具发票，可以作废</p>
      <p class="n_txt" v-else>此结算单已开具发票，不可以作废</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="voidVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="saveVoidHandle" size="small" :loading="isBtnLoading" v-if="!statementQuery.invoiceHasBeenIssued">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="hcForm.manualOrNot ? '手工登记红冲' : type2 =='view' ? '查看' : '整笔红冲'" :visible.sync="showHC" width="700px" class="res_dialog void_dialog">
      <div class="p_employee_list" v-if="showHC">
        <div class="p_employee_form">
          <div class="p_employee_item">
            <p class="emp_txt">发票张数:</p>
            <div class="emp_form_txt">
              {{hcInfo.invoiceCount}}
            </div>
          </div>
          <div class="p_employee_item">
            <p class="emp_txt">发票类型:</p>
            <div class="emp_form_txt">
              {{hcInfo.ticketType.toString() }}
            </div>
          </div>
          <div class="p_employee_item">
            <p class="emp_txt">开票方式:</p>
            <div class="emp_form_txt">
              {{hcInfo.billingMethod.toString()}}
            </div>
          </div>
          <div class="p_employee_item">
            <p class="emp_txt">开票金额:</p>
            <div class="emp_form_txt">
              {{hcInfo.amount}}
            </div>
          </div>
          <div class="p_employee_item">
            <p class="emp_txt">税额:</p>
            <div class="emp_form_txt">
              {{hcInfo.amountTax}}
            </div>
          </div>
          <!-- <div class="p_employee_item">
            <p class="emp_txt">介质:</p>
            <div class="emp_form_txt">
              {{hcInfo.ticketType}}
            </div>
          </div> -->
          <div class="p_employee_item" style="width:100%">
            <p class="emp_txt">发票号码:</p>
            <div class="emp_form_txt2">
              {{hcInfo.invoiceNumber.toString()}}
              <span class="blueName cp" style="margin-left: 15px;" @click="downInvoice()" v-if="!isDowning">下载</span>
              <i class="el-icon-loading" v-else></i>
            </div>
          </div>
          <div class="p_employee_item" style="width: 100%;">
            <p class="emp_txt">法务实体:</p>
            <div class="emp_form_txt2">
              {{hcInfo.strLegalsubName}}
            </div>
          </div>
          <!-- <div class="p_employee_item">
            <p class="emp_txt">客户名称:</p>
            <div class="emp_form_txt">
              {{hcInfo.strCustShortName}}
            </div>
          </div> -->
          <div class="p_employee_item">
            <p class="emp_txt">开票时间:</p>
            <div class="emp_form_txt">
              {{hcInfo.billingTime ? hcInfo.billingTime.toString().replace('T',' ')  : ''}}
            </div>
          </div>
          <div class="p_employee_item">
            <p class="emp_txt">开票申请时间:</p>
            <div class="emp_form_txt">
              {{hcInfo.applicationTime ? hcInfo.applicationTime.replace('T',' ') : ''}}
            </div>
          </div>
        </div>
      </div>
      <el-form ref="hcForm" :model="hcForm" label-width="120px" :rules="hcRules" v-if="type2!='view'">
        <el-form-item label="红冲备注:" prop="operatingRemarks">
          <el-input type="textarea" v-model="hcForm.operatingRemarks" :autosize="{ minRows: 4}" style="width:400px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="type2!='view'">
        <el-button @click="showHC = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmHC" v-preventReClick size="small" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="hcForm.manualOrNot ? '手工登记红冲' : type2 =='view' ? '查看' : '红冲'" :visible.sync="showHCDZ" width="700px" class="res_dialog void_dialog">
      <div class="p_employee_list" v-if="showHCDZ">
        <div class="p_employee_form">
          <div class="p_employee_item">
            <p class="emp_txt">发票类型:</p>
            <div class="emp_form_txt">
              {{hcInfo.ticketType}}
            </div>
          </div>
          <!-- <div class="p_employee_item">
            <p class="emp_txt">票种:</p>
            <div class="emp_form_txt">
              {{hcInfo.ticketType }}
            </div>
          </div> -->
          <div class="p_employee_item" style="width:100%">
            <p class="emp_txt">发票号码:</p>
            <div class="emp_form_txt2">
              {{hcInfo.invoiceNumber.toString()}}
              <span class="blueName cp" style="margin-left: 15px;" @click="downInvoice()" v-if="!isDowning">下载</span>
              <i class="el-icon-loading" v-else></i>
            </div>
          </div>
          <div class="p_employee_item">
            <p class="emp_txt">开票方式:</p>
            <div class="emp_form_txt">
              {{hcInfo.billingMethod}}
            </div>
          </div>
          <div class="p_employee_item">
            <p class="emp_txt">项目名称:</p>
            <div class="emp_form_txt2">
              {{hcInfo.ownershipName}}
            </div>
          </div>
          <!-- <div class="p_employee_item" style="width: 100%;">
            <p class="emp_txt">客户名称:</p>
            <div class="emp_form_txt2">
              {{hcInfo.strCustShortName}}
            </div>
          </div> -->
          <div class="p_employee_item" style="width: 100%;">
            <p class="emp_txt">法务实体:</p>
            <div class="emp_form_txt2">
              {{hcInfo.strLegalsubName}}
            </div>
          </div>
          <div class="p_employee_item">
            <p class="emp_txt">开票时间:</p>
            <div class="emp_form_txt">
              {{hcInfo.billingTime ? hcInfo.billingTime.toString().replace('T',' ') : ''}}
            </div>
          </div>
          <div class="p_employee_item">
            <p class="emp_txt">开票申请时间:</p>
            <div class="emp_form_txt">
              {{hcInfo.applicationTime ? hcInfo.applicationTime.replace('T',' ') : ''}}
            </div>
          </div>
          <div class="p_employee_item">
            <p class="emp_txt">状态:</p>
            <div class="emp_form_txt">
              {{hcInfo.status=='成功' ? '已开票' : hcInfo.status}}
            </div>
          </div>
          <div class="p_employee_item">
            <p class="emp_txt">开票备注:</p>
            <div class="emp_form_txt">
              {{hcInfo.remark}}
            </div>
          </div>
        </div>
      </div>
      <el-form ref="hcForm" :model="hcForm" label-width="120px" :rules="hcRules" v-if="type2!='view'">
        <el-form-item label="红冲备注:" prop="operatingRemarks">
          <el-input type="textarea" v-model="hcForm.operatingRemarks" :autosize="{ minRows: 4}" style="width:400px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="type2!='view'">
        <el-button @click="showHCDZ = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmHC" v-preventReClick size="small" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="退回" :visible.sync="showBack" width="460px" class="res_dialog void_dialog">
      <el-form ref="backForm" :model="handelForm" label-width="80px" :rules="backRule">
        <el-form-item label="退回原因:">
          <el-select v-model="handelForm.reason" size="small" filterable clearable style="width:300px">
            <el-option value="科目有误"></el-option>
            <el-option value="金额有误"></el-option>
            <el-option value="客户信息有误"></el-option>
            <el-option value="备注有误"></el-option>
            <el-option value="其他原因"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退回说明:">
          <el-input v-model="handelForm.remark" size="small" clearable style="width:300px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBack = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmBack" v-preventReClick size="small" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="登记线下开票" :visible.sync="showSign" width="600px" class="res_dialog void_dialog">
      <div class="billTip">请确认选中的开票申请已开票：</div>
      <el-table :data="multipleSelection" class="doc_table">
        <el-table-column prop="ownershipName" label="项目名称" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="amountBilled" label="发票待办金额" min-width="120" :show-overflow-tooltip="true" align="center">
          <template slot-scope="{row}">￥{{row.amountBilled}}</template>
        </el-table-column>
        <el-table-column prop="amount" label="本次开票金额" min-width="120" :show-overflow-tooltip="true" align="center">
          <template slot-scope="{row}">￥{{row.amount}}</template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSign = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmSign" v-preventReClick size="small" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择发票格式" :visible.sync="showDown" width="450px">
      <div>
        <el-form>
          <el-form-item label="发票格式:">
            <el-select v-model="wjlx" size="small" placeholder="" style="width: 180px;">
              <el-option value="PDF">
              </el-option>
              <el-option value="OFD">
              </el-option>
              <el-option value="XML">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDown = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmDownInvoice" size="small" :loading="isDowning">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="登录" :visible.sync="showLogin" width="530px" class="res_dialog enter_dialog">
      <el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="re_down_form" label-width="100px">
        <el-form-item label="法务主体:" prop="qymc">
          <el-select v-model="loginForm.qymc" placeholder="" size="small" style="width: 300px;" filterable @change="changeSub2">
            <el-option v-for="(item, index) in legList" :key="index" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="税号:" prop="nsrsbh">
          <el-input v-model="loginForm.nsrsbh" size="small" clearable style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="zrrsjh">
          <el-input v-model="loginForm.zrrsjh" type="number" size="small" clearable style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="登录密码:" prop="zrrmm">
          <el-input type="password" v-model="loginForm.zrrmm" size="small" prefix-icon="el-icon-lock" show-password style="width: 300px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showLogin = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmLogin" size="small" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="认证" :visible.sync="showAuthentication" width="450px">
      <el-form>
        <el-form-item label="二维码类型:">
          <el-select v-model="ewmlx" size="small" @change="changeEwmlx" placeholder="" style="width: 180px;">
            <el-option label="税务APP" :value="1">
            </el-option>
            <el-option label="个税APP" :value="2">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-image style="width: 300px; height: 300px;margin-left:50px" v-if="QRCodeSrc" :src="QRCodeSrc" alt="" @click="getQRCode"></el-image>
      <div class="qrTips" v-if="qrLoading">二维码加载中...</div>
      <!-- <el-button>重新获取二维码</el-button> -->
      <div v-if="isTimeout" class="qrTips">网络连接超时或异常</div>
      <div class="qrTips" v-if="ewmlx && !qrLoading">请使用{{ewmlx==1?'税务APP' : '个税APP'}}扫码认证</div>
      <!-- <div @click="getQRStatus">111</div> -->
    </el-dialog>
  </div>
</template>

<script>
  import {
    row
  } from "mathjs";
  import xz from "./../../common";
  import FUN from "./../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  // import ResourceComTabs from "./components/resourceComTabs.vue"
  export default {
    components: {
      // ResourceComTabs
    },
    data() {
      return {
        pageTitle: '费用结算单',
        showDown: false,
        wjlx: 'PDF',
        enterBtnType: '',
        numQuery: {
          num1: 0,
          price1: 0,
          price2: 0,
        },
        isBtnLoading: false,
        dedpartNameList: [],
        // 部门参数
        departQuery: {
          strorgancode: '',
          roletype: ''
        },
        departMemberQuery: {
          keyword: '',
          strWorkState: '在职',
          currpage: 1,
          perpage: 100000
        },
        // 部门列表
        departList: [],
        // 人员列表
        memberList: [],
        // 自定义 级联选择props
        propPosition: {
          label: 'strParametername',
          value: 'strParameterid',
          children: 'children',
          checkStrictly: true
        },
        props: {
          label: 'strorganname',
          value: 'strorgancode',
          children: 'children',
          checkStrictly: true
        },
        tableHeight: 0,
        showDropScreen: -1,
        isDowning: false,
        activeName: '0',
        activeName2: '0',
        // 列表参数
        listQuery: {
          ownershipMonth: "",
          projectid: "",
          strorgancode: "",
          custid: "",
          subjectOfLegalAffairsId: "",
          strpartner2: "",
          strAchieveowner: "",
          strservuserid: "",
          strservuserDep: "",
          strGroupName: "",
          start: "",
          end: "",
          founder: Cookies.get("userid-b"), //创建人id
          pagination: {
            page: 1,
            pageSize: 10,
            orders: [{
              property: 'createTime',
              order: 1
            }]
          }
        },
        hcInfo: {
          invoiceCount: 1
        },
        hcForm: {
          type: 0, //类型1：开票申请2：实际开票
          id: "",
          status: 0, //状态-2：红冲-1：作废
          operatingRemarks: "", //操作备注
          operator: ""
        },
        type: '',
        rowInfo: [],
        showHC: false,
        // 导出参数
        loading: false,
        tableData: [],
        multipleSelection: [],
        roleType: localStorage.loginRoletype,
        labelActiveName: '全局标签',
        btnLoading: false,
        showHCDZ: false,
        showSign: false,
        // 是否能点击搜索按钮
        isSearchHandle: false,
        // 按钮权限参数
        butQuery: {
          path: '/invoicing',
          powerEnName: 'invoicing'
        },
        permissionLists: [],
        sheetList: [], //核算单编号
        // 项目列表
        totalCount: 0,
        projectList: [],
        // 项目名称列表参数
        proNameQuery: {
          searchVal: '',
          pageSize: 100000000,
          pageNum: 1
        },
        dedpartVal: [], //服务部门
        dedpartDiaVal: [], //结算单归属部门
        //具体信息列表
        decInfoList: [],
        argument: '',
        showLogin: false,
        loginForm: {},
        showAuthentication: false,
        qrLoading: false,
        QRCodeSrc: '',
        ewmlx: '',
        isTimeout: false,
        interval: null,
        subjectOfLegalAffairsId: '',
        rzid: '',
        loginRules: {
          qymc: {
            required: true,
            message: "请选择法务主体",
            trigger: "change",
          },
          nsrsbh: {
            required: true,
            message: "请输入税号",
            trigger: "blur",
          },
          zrrsjh: {
            required: true,
            message: "请输入登录手机",
            trigger: "blur",
          },
          zrrmm: {
            required: true,
            message: "请输入登录密码",
            trigger: "blur",
          },
        },
        isExping: false,
        statementVisible: false, //上传结算单
        statementQuery: { //上传结算单参数
          type: 1, //归属类型1：项目2：部门
          ownershipId: "", //归属id
          ownershipMonth: "", //归属月
          amount: 0, //结算单金额
          remark: "", //结算单备注
          files: [], //结算单附件地址
          finalStatementId: "", //结算单id
          founder: Cookies.get("userid-b"), //创建人
        },
        statementRules: {
          type: {
            required: true,
            message: '请选择归属',
            trigger: 'change'
          },
          ownershipMonth: {
            required: true,
            message: '请选择归属月',
            trigger: 'change'
          },
          amount: {
            required: true,
            message: '请输入结算金额',
            trigger: 'change'
          },
          files: {
            required: true,
            message: '请上传结算单附件',
            trigger: 'change'
          },
        },
        hcRules: {
          operatingRemarks: {
            required: true,
            message: '请输入红冲备注',
            trigger: 'blur'
          }
        },
        addStateVisible: false,
        type2: '',
        stateTitle: '上传结算单',
        legList: [],
        stateFileList: [], //结算单附件
        custList: [],
        addRules: { //增加结算单规则
          num: [{
            required: true,
            message: '请输入结算单金额',
            trigger: 'blur'
          }],
          url: [{
            required: true,
            message: '请上传结算单附件',
            trigger: 'change'
          }]
        },
        addQuery: {
          type: '', // 归属类型
          Projectid: '',
          departid: '',
          month: '2024-03', //归属月
          num: '', //结算单金额
          remark: '', //备注
          url: '' //附件
        },
        voidVisible: false,
        needLoading: false,
        showBack: false,
        handelForm: {
          invoiceId: "", //发票id
          status: 0, //状态-1：退回0：提交
          reason: "", //原因（退回使用）
          remark: "", //备注
          operator: Cookies.get("userid-b") //操作人
        },
        backRule: {
          reason: {
            required: true,
            message: '请选择退回原因',
            trigger: 'change'
          }
        },
        voidQuery: {
          name: '杰博',
          month: '2024-02',
          num: '1111',
          date: '2024-05-05',
          user: 'ss'
        },
        allQuery: {
          subjectOfLegalAffairs: '',
          nsrsbh: "",
          areaid: "",
          kprqq: "",
          kprqz: "",
          fphm: "",
          zzfphm: "",
          zzfpdm: "",
          pageNo: 1,
          pageSize: 10,
          cxlx: 1
        },
        subjectOfLegalAffairs: '', //主体
        allData: [],
        allTotal: 0,
        allRules: {
          subjectOfLegalAffairs: {
            required: true,
            message: '请选择主体',
            trigger: 'change'
          },
          kprqq: {
            required: true,
            message: '请选择开票起始时间',
            trigger: 'change'
          },
          kprqz: {
            required: true,
            message: '请选择开票结束时间',
            trigger: 'change'
          },
        }
      }
    },
    created() {
      this.loginRoleType = localStorage.loginRoletype;
      this.decInfoList = [{
        name: '总批数',
        type: '1',
        num1: 0,
        num2: 0,
        num3: 0,
        num4: 0,
        num5: 0
      }]
      this.getButtonPower()
      // 部门列表
      this.getDepartList()
      this.calHeight()
      this.getProNameList() //项目列表

      this.getlegalsubjectlist();
      if (this.$route.query.activeName != undefined && this.$route.query.activeName) {
        this.activeName = this.$route.query.activeName;
        this.changeTab();
        if (this.$route.query.status == 'back' && this.$route.query.subId != undefined) {
          this.subjectOfLegalAffairsId = this.$route.query.subId;
          this.changeSub2(this.subjectOfLegalAffairsId);
        }
      } else {
        this.getList();
      }
    },
    mounted() {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && this.needLoading) {
          this.getList()
          this.needLoading = false;
        } else {}
      })
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
              if (that.checkPermission(['publicResources_page_list'], that.permissionLists)) {}
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          keyWord: '',
          pageSize: '10000'
        }
        xz.BasicFun(data, 'GetSubjectOfLegalAffairs').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data;
          } else {
            this.legList = [];
          }
        })
      },
      // 提交申请
      submitHandle(row) {
        this.loading = true;
        let data = {
          invoiceIds: [row.invoiceId], //发票id
          status: 0, //状态 -1：退回  0：提交  -2作废
          reason: "", //原因（退回使用）
          remark: "", //备注
          operator: Cookies.get("userid-b") //操作人
        }
        this.loading = true;
        xz.IvoiceFun(data, 'SetInvoiceSaveChangeAsStatus').then(res => {
          if (res.status == 'ok') {
            this.$message.success('提交成功')
            this.getList();
            this.loading = false;
          } else {
            this.$message.error(res.msg)
            this.getList();
            this.loading = false;
          }
        })
      },
      // 查看
      DtlHandle(row) {
        this.$router.push({
          path: "/pendInvoice",
          query: {
            id: row.invoiceId,
            type: 'bc',
            activeName: this.activeName
          }
        });
      },
      DtlHandle2(row) {
        this.$router.push({
          path: "/pendInvoice",
          query: {
            id: row.actualBillingBasicId,
            type: 'az',
            activeName: this.activeName
          }
        });
      },
      // 结算单查看
      dtlSettleHandle(row) {
        this.$router.push({
          path: "/balanceDtl",
          query: {
            id: row.finalStatementId
          }
        });
      },
      // 上传结算单显示弹框
      statementHandle() {
        this.statementQuery = {
          type: 1, //归属类型1：项目2：部门
          ownershipId: "", //归属id
          ownershipMonth: "", //归属月
          amount: 0, //结算单金额
          remark: "", //结算单备注
          files: [], //结算单附件地址
          finalStatementId: "", //结算单id
          founder: Cookies.get("userid-b"), //创建人
        }
        this.dedpartDiaVal = '';
        this.stateFileList = [];
        this.stateTitle = '上传结算单';
        this.statementVisible = true;
      },
      // 确定上传结算单
      saveStatementHandle() {
        this.$refs['statementForm'].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.IvoiceFun(this.statementQuery, 'SetFinalStatementSave').then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功');
                this.isBtnLoading = false;
                this.statementVisible = false;
                this.getList()
              } else {
                this.$message.error(res.msg);
                this.isBtnLoading = false;
              }
            })
          }
        })
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 5 个文件`);
      },
      // 删除结算单附件
      handleFileRemove() {
        this.statementQuery.fileUrl = '';
      },
      // 上传结算单附件
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            // this.statementQuery.fileUrl = res;
            let data = {
              fileUrl: res,
              fileName: file.name
            }
            this.statementQuery.files.push(data)
            this.$refs['statementForm'].validate()
          } else {
            this.statementQuery.fileUrl = ''
          }
        });
      },
      // 选择归属部门
      departChange(val) {
        // console.log('111', val)
        if (val) {
          this.listQuery.strorgancode = val[val.length - 1]
        } else {
          this.listQuery.strorgancode = ''
        }
      },
      // 选择服务部门
      departChange2(val) {
        if (val) {
          this.listQuery.strservuserDep = val[val.length - 1]
        } else {
          this.listQuery.strservuserDep = ''
        }
      },
      departSerChange(val) {
        // console.log('111', val)
        if (val) {
          this.listQuery.depart = val[val.length - 1]
        } else {
          this.listQuery.depart = ''
        }
      },
      departDiaChange(val) {
        this.statementQuery.ownershipId = val[val.length - 1];
        this.$refs.cascaderDep._data.dropDownVisible = false;
      },
      getRowKeys(row) { //唯一值
        // console.log(row.id)
        return row.userIds;
      },
      // 增加结算单
      addStateHandle(row) {
        this.info = row;
        this.stateTitle = '增加结算单';
        this.addStateVisible = true;
      },
      // 确定新增结算单
      saveAddHandle() {
        this.addStateVisible = false
      },
      // 修改
      modifyHandle(row) {
        xz.GetFinalStatementEdit(row.finalStatementId).then(res => {
          try {
            if (res.status == 'ok') {
              this.statementQuery = res.data[0];
              this.statementQuery.ownershipId = Number(this.statementQuery.ownershipId);
              this.statementQuery.FinalStatementId = row.finalStatementId;
              this.statementQuery.Founder = Cookies.get("userid-b");
              this.stateTitle = '修改结算单';
              this.statementVisible = true
            } else {
              this.$message.error('获取详情出错')
            }
          } catch (e) {
            console.log(e)
          }
        })
      },
      // 作废
      voidHandle(row) {
        this.id = row.finalStatementId;
        xz.GetFinalStatementEdit(row.finalStatementId).then(res => {
          try {
            if (res.status == 'ok') {
              this.statementQuery = res.data[0];
              this.statementQuery.ownershipId = Number(this.statementQuery.ownershipId)
              this.voidVisible = true;
            } else {
              this.$message.error('获取详情出错')
            }
          } catch (e) {
            console.log(e)
          }
        })
      },
      // 确定作废
      saveVoidHandle() {
        this.isBtnLoading = true;
        let d = {
          ids: [this.id],
          status: 1 //0有效1作废
        }
        xz.IvoiceFun(d, 'SetFinalStatementChangeAsStatus').then(res => {
          if (res.status == 'ok') {
            this.$message.success('作废成功！');
            this.voidVisible = false
            this.isBtnLoading = false;
            this.getList();
          } else {
            this.$message.error(res.msg);
            this.voidVisible = false
            this.isBtnLoading = false;
            this.getList();
          }
        })
      },
      //申请列表作废
      delInv(row) {
        let data = {
          invoiceIds: [row.invoiceId], //发票id
          status: -2, //状态-1：退回0：提交 -2作废
          reason: "", //原因（退回使用）
          remark: "", //备注
          operator: Cookies.get("userid-b") //操作人
        }
        this.confirmDel(data)
      },
      batchDel() {
        if (this.multipleSelection.length > 0) {
          let arr = []
          this.multipleSelection.forEach((e, i) => {
            arr.push(e.invoiceId)
            if (i == this.multipleSelection.length - 1) {
              let d = {
                invoiceIds: arr, //发票id
                status: -2, //状态-1：退回0：提交 -2作废
                reason: "", //原因（退回使用）
                remark: "", //备注
                operator: Cookies.get("userid-b") //操作人
              }
              this.confirmDel(d)
            }
          });
        } else {
          this.$message.warning('请至少选择一条')
        }
      },
      confirmDel(d) {
        this.loading = true;
        xz.IvoiceFun(d, 'SetInvoiceSaveChangeAsStatus').then(res => {
          if (res.status == 'ok') {
            this.$message.success('作废成功')
            this.getList();
            this.loading = false;
          } else {
            this.$message.error(res.msg)
            this.getList();
            this.loading = false;
          }
        })
      },
      // 申请重开
      reopenHandle() {
        // this.$router.push({
        //   path: '/reopen'
        // })
      },
      // 申请开票
      applyHandle() {
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: "/updateInvoice",
          query: {
            type: 'apply'
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      // 编辑
      editHandle(row) {
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: "/updateInvoice",
          query: {
            type: 'edit',
            id: row.invoiceId
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      // 发票待办--开票(单个)
      singleInvoiceHandle(row) {
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: "/pendInvoiceMul",
          query: {
            type: 'single',
            id: row.invoiceId
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      // 开票--无申请/多个
      mulInvoiceHandle() {
        this.needLoading = true;
        if (this.multipleSelection.length == 0) {
          const routerUrl = this.$router.resolve({
            path: "/updateInvoice",
            query: {
              type: 'noApply'
            }
          });
          const newWindow = window.open(routerUrl.href, "_blank");
        }
        // else if (this.multipleSelection.length == 1) {
        //   this.singleInvoiceHandle(this.multipleSelection[0])
        // } 
        else {
          let arr = []
          let canMul = true;
          let company = this.multipleSelection[0].strLegalsubName;
          this.multipleSelection.forEach(element => {
            arr.push(element.invoiceId)
            if (company != element.strLegalsubName) {
              canMul = false
            }
            if (index == this.multipleSelection.length - 1) {
              if (canMul) {
                this.needLoading = true;
                const routerUrl = this.$router.resolve({
                  path: "/pendInvoiceMul",
                  query: {
                    type: 'mul',
                    id: arr.toString()
                  }
                });
                const newWindow = window.open(routerUrl.href, "_blank");
              } else {
                this.$message.warning('请选择同一个主体的开票')
              }
            }
          });
        }
      },
      noAppInvoiceHandle() {
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: "/noApplicationInv"
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      // 登记线下开票
      registHandle() {
        if (this.multipleSelection.length > 0) {
          this.showSign = true;
        } else {
          this.$message.warning('请至少选择一个')
        }
      },
      changeTab() {
        this.activeName2 = '0';
        if (this.activeName == '0') {
          this.pageTitle = '费用结算单';
          this.listQuery = {
            ownershipMonth: this.listQuery.ownershipMonth,
            projectid: this.listQuery.projectid,
            strorgancode: "",
            custid: "",
            subjectOfLegalAffairsId: this.listQuery.subjectOfLegalAffairsId,
            strpartner2: "",
            strAchieveowner: "",
            strservuserid: "",
            strservuserDep: "",
            strGroupName: "",
            start: "",
            end: "",
            founder: Cookies.get("userid-b"),
            pagination: {
              page: 1,
              pageSize: 10,
              orders: [{
                property: 'createTime',
                order: 1
              }]
            }
          }
          this.getList();
        } else if (this.activeName == '1') {
          this.pageTitle = '开票申请';
          this.listQuery = {
            ownershipMonth: this.listQuery.ownershipMonth,
            projectid: this.listQuery.projectid,
            strorgancode: "",
            custid: "",
            subjectOfLegalAffairsId: this.listQuery.subjectOfLegalAffairsId,
            strpartner2: "",
            strAchieveowner: "",
            strservuserid: "",
            strservuserDep: "",
            strGroupName: "",
            start: "",
            end: "",
            founder: Cookies.get("userid-b"),
            pagination: {
              page: 1,
              pageSize: 10,
              orders: [{
                property: 'applicationTime',
                order: 1
              }]
            },
            applicant: "",
            invoiceNo: "",
            billingMethod: 0,
            ticketType: "",
            status: 0
          }
          this.getList();
        } else if (this.activeName == '2') {
          this.pageTitle = '发票待办';
          this.listQuery = {
            "ownershipMonth": this.listQuery.ownershipMonth, //归属月
            "projectid": this.listQuery.projectid, //归属项目
            "strorgancode": "", //归属部门
            "custid": "", //客户
            "subjectOfLegalAffairsId": this.listQuery.subjectOfLegalAffairsId, //开票主体
            "strpartner2": "", //业务员
            "strAchieveowner": "", //合伙人
            "strservuserid": "", //客服
            "strservuserDep": "", //服务部门
            "strGroupName": "", //客户集团
            "start": "", //开始时间
            "end": "", //结束时间
            "pagination": {
              "page": 1,
              "pageSize": 10,
              orders: [{
                property: 'applicationTime',
                order: 1
              }]
            },
            founder: Cookies.get("userid-b"),
            "applicant": "", //申请人
            "invoiceNo": "", //申请单号
            "billingMethod": 0, //开票方式
            "ticketType": "", //票种id
          }
          this.getList();
        } else if (this.activeName == '3') {
          this.pageTitle = '部分开票';
          this.listQuery = {
            "ownershipMonth": this.listQuery.ownershipMonth,
            "projectid": this.listQuery.projectid,
            "strorgancode": "",
            "custid": "",
            "subjectOfLegalAffairsId": this.listQuery.subjectOfLegalAffairsId,
            "strpartner2": "",
            "strAchieveowner": "",
            "strservuserid": "",
            "strservuserDep": "",
            "strGroupName": "",
            "start": "",
            "end": "",
            founder: Cookies.get("userid-b"),
            "pagination": {
              "page": 1,
              "pageSize": 10,
              orders: []
            },
            "applicant": "",
            "invoiceNo": "",
            "billingMethod": 0,
            "ticketType": "",
            "drawer": "",
            "actualBillingNo": ""
          }
          this.getList();
        } else if (this.activeName == '4') {
          this.pageTitle = '已开票';
          this.listQuery = {
            "ownershipMonth": this.listQuery.ownershipMonth,
            "projectid": this.listQuery.projectid,
            "strorgancode": "",
            "custid": "",
            "subjectOfLegalAffairsId": this.listQuery.subjectOfLegalAffairsId,
            "strpartner2": "",
            "strAchieveowner": "",
            "strservuserid": "",
            "strservuserDep": "",
            "strGroupName": "",
            "start": "",
            "end": "",
            invoiceNumber: '',
            founder: Cookies.get("userid-b"),
            "pagination": {
              "page": 1,
              "pageSize": 10,
              "orders": [{
                "property": "applicationTime",
                "order": 1
              }]
            },
            "applicant": "",
            "invoiceNo": "",
            "billingMethod": 0,
            "ticketType": "",
            "drawer": "",
            "actualBillingNo": "",
            "billingContent": ""
          }
          this.activeName2 = '2';
          this.changeTab2();
        } else if (this.activeName == '5') {
          this.pageTitle = '废票/红冲记录';
          this.listQuery = {
            "ownershipMonth": this.listQuery.ownershipMonth,
            "projectid": this.listQuery.projectid,
            "strorgancode": "",
            "custid": "",
            "subjectOfLegalAffairsId": this.listQuery.subjectOfLegalAffairsId,
            "strpartner2": "",
            "strAchieveowner": "",
            "strservuserid": "",
            "strservuserDep": "",
            "strGroupName": "",
            "start": "",
            "end": "",
            founder: Cookies.get("userid-b"),
            "pagination": {
              "page": 1,
              "pageSize": 10,
              "orders": [{
                "property": "operatingTime",
                "order": 1
              }]
            },
            "applicant": "",
            "invoiceNo": "",
            "billingMethod": 0,
            "ticketType": "",
            "drawer": "",
            "actualBillingNo": "",
            "billingContent": "",
            "status": 0
          }
          this.activeName2 = '3';
          this.changeTab2();
        } else if (this.activeName == '6') {
          this.pageTitle = '全量查询';
        }
      },
      changeTab2(tab) {
        if (this.activeName2 == '1') {
          this.listQuery.status = -1;
          this.GetFinalStatementList('GetInvoiceSendBackList')
        } else if (this.activeName2 == '0') {
          this.changeTab()
        } else if (this.activeName2 == '2') {
          this.listQuery.invoiceNumber = "";
          this.GetFinalStatementList('GetPressingAlreadyInvoiceList')
        } else if (this.activeName2 == '3') {
          this.GetFinalStatementList('GetSingleVoidRedPunchInvoiceList')
        }
      },
      // 获取项目列表
      getProNameList() {
        xz.getplancomrecordprojectlist(this.proNameQuery, localStorage.loginRoletype).then(res => {
          // console.log('项目名称列表', res)
          if (res.status == 'ok') {
            this.projectList = res.data
          } else {
            this.projectList = []
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
          if (this.memberList.length == 0) {
            // 人员列表
            this.getMemberList();
            this.getCustLists();
          }
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      // 表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //数组去重
      unique(arr) {
        for (let i = 0; i < arr.length; i++) {
          for (let j = i + 1; j < arr.length; j++) {
            if (arr[i].toString() == arr[j].toString()) {
              arr.splice(j, 1);
              j--;
            }
          }
        }
        return arr;
      },
      //分页
      handleCurrentChange(val) {
        this.listQuery.pagination.page = Number(val)
        this.getList()
      },
      handleSizeChange(val) {
        this.listQuery.pagination.page = 1
        this.listQuery.pagination.pageSize = Number(val)
        this.getList()
      },
      // 获取列表
      getList() {
        switch (this.activeName) {
          case '0':
            this.GetFinalStatementList('GetFinalStatementList'); //结算单
            break;
          case '1':
            this.GetFinalStatementList('GetInvoiceApplicationList'); //开票申请
            break;
          case '2':
            this.GetFinalStatementList('GetInvoiceAgentList'); //发票代办
            break;
          case '3':
            this.GetFinalStatementList('GetPartialBillingList'); //部分开票
            break;
          case '4':
            if (this.activeName2 == '0') {
              this.GetFinalStatementList('GetAlreadyInvoiceList');
            } else {
              this.GetFinalStatementList('GetPressingAlreadyInvoiceList')
            }
            break;
          case '5':
            if (this.activeName2 == '0') {
              this.GetFinalStatementList('GetvoidRedPunchInvoiceList');
            } else {
              this.GetFinalStatementList('GetSingleVoidRedPunchInvoiceList')
            }
            break;
        }
      },
      //获取结算单列表
      GetFinalStatementList(pagename) {
        this.loading = true
        xz.IvoiceFun(this.listQuery, pagename).then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.tableData = res.data.data ? res.data.data : [];
            this.totalCount = res.data.totalCount;
            this.argument = res.data.argument;
          } else {
            this.loading = false;
            this.tableData = [];
            this.totalCount = 0;
          }
        })
      },
      clickRowLoad(r, c, e) {
        if (e.currentTarget.firstElementChild.firstElementChild.firstElementChild.tagName == 'DIV') {
          e.currentTarget.firstElementChild.firstElementChild.firstElementChild.click()
        } else {
          e.currentTarget.firstElementChild.firstElementChild.firstElementChild.nextElementSibling.click()
        }
      },
      //展开表格
      handleExpandChange(row, rows) {
        row.isExpand = !row.isExpand
        // if (rows.length > 1) {
        //   this.expands = []
        //   this.$refs.elTable.toggleRowExpansion(rows[0]);
        // }
      },
      // 搜索
      searchHandle() {
        this.listQuery.currpage = 1
        // this.showDropScreen = -1
        this.getList()
      },
      // 导出
      exportHandle() {},
      // 获取员工列表
      getMemberList() {
        xz.getauthUserInfoByorgancode(this.departMemberQuery).then(res => {
          // console.log('员工', res)
          if (res.status == 'ok') {
            this.memberList = res.msg
          } else {
            this.memberList = []
          }
        })
      },
      // 获取部门列表
      getDepartList() {
        xz.getorganstr('', localStorage.loginRoletype, {
          strIsDisable: 1
        }).then(res => {
          if (res.status == 'ok') {
            this.departList = res.msg.parent[0].children
          } else {
            this.departList = []
          }
        })
      },
      // 清空
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight)
        //   console.log('height',this.tableHeight)
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
      },
      handelBack(row) {
        this.handelForm = {
          invoiceIds: [row.invoiceId], //发票id
          status: -1, //状态-1：退回0：提交
          reason: "", //原因（退回使用）
          remark: "", //备注
          operator: Cookies.get("userid-b") //操作人
        }
        this.showBack = true;
      },
      batchBack() {
        if (this.multipleSelection.length > 0) {
          let arr = []
          this.multipleSelection.forEach((e, i) => {
            arr.push(e.invoiceId)
            if (i == this.multipleSelection.length - 1) {
              this.handelForm = {
                invoiceIds: arr, //发票id
                status: -1, //状态-1：退回0：提交
                reason: "", //原因（退回使用）
                remark: "", //备注
                operator: Cookies.get("userid-b") //操作人
              }
              this.showBack = true;
            }
          });
        } else {
          this.$message.warning('请至少选择一条')
        }
      },
      confirmBack() {
        this.$refs["backForm"].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.IvoiceFun(this.handelForm, 'SetInvoiceSaveChangeAsStatus').then(res => {
              if (res.status == 'ok') {
                this.$message.success('退回成功')
                this.getList();
                this.isBtnLoading = false;
                this.showBack = false;
              } else {
                this.$message.error(res.msg)
                this.getList();
                this.isBtnLoading = false;
              }
            })
          }
        })
      },
      //红冲
      followHandle(row, id, type, type2) {
        this.type2 = type2;
        this.subjectOfLegalAffairsId = row.legalsubid;
        this.loginForm.qymc = row.legalsubid;
        this.id = [id];
        this.rowInfo = row;
        let pagename = type == 1 ? 'GetAlreadyInvoiceView' : 'GetSingleAlreadyInvoiceView';
        xz.GetAlreadyInvoiceView(id, pagename).then(res => {
          if (res.status == 'ok') {
            // console.log()
            this.hcInfo = res.data[0];
            this.hcForm = {
              type, //类型1：整笔 2：按张
              id,
              status: -2, //状态-2：红冲-1：作废
              operatingRemarks: "", //操作备注
              operator: Cookies.get("userid-b"),
              manualOrNot: false
            }
            if (type2 == 'handel') {
              this.hcForm.manualOrNot = true;
            }
            if (type == 1) {
              this.showHC = true;
            } else {
              this.showHCDZ = true;
            }
            console.log(this.hcInfo)
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      confirmHC() {
        this.$refs['hcForm'].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.IvoiceFun(this.hcForm, 'SetAlreadyInvoiceChangeStatus').then(res => {
              if (res.status == 'ok') {
                this.$message.success('操作成功！')
                this.isBtnLoading = false;
                this.showHC = false;
                this.showHCDZ = false;
                this.getList();
              } else {
                this.$message.error(res.msg)
                // this.showHC = false;
                // this.showHCDZ = false;
                this.getList();
                if (res.msg.indexOf('扫脸认证已超时') > -1) {
                  this.changeSub2(this.subjectOfLegalAffairsId);
                  setTimeout(() => {
                    this.showAuthentication = true;
                    this.isBtnLoading = false;
                  }, 500);
                } else if (res.msg.indexOf('登录') > -1) {
                  this.changeSub2(this.subjectOfLegalAffairsId);
                  setTimeout(() => {
                    this.showLogin = true;
                    this.isBtnLoading = false;
                  }, 500);
                } else {
                  this.isBtnLoading = false;
                }
              }
            })
          }
        })
      },
      loginHandel() {
        this.loginForm = {
          qymc: '',
          nsrsbh: '',
          areaid: '',
          ljlx: 'PC', //链接类型 PC、H5
          rzcghddz: '', //认证成功回调地址(base64编码)
          ycsbhddz: '', //异常失败回调地址(base64编码
          fhdz: '',
          zrrsjh: '',
          zrrsf: 14, //自然人身份1：办税员2：法定代表人3：财务负责人6：领票人8：社保经办人14：开票员
          zrrmm: '',
        };
        this.showLogin = true;
      },
      downInvoice() {
        this.type = 'single';
        this.isDowning = false;
        this.showDown = true;
      },
      downRowInvoice(row) {
        this.id = [row.actualBillingBasicId];
        this.type = 'single';
        this.isDowning = false;
        this.showDown = true;
      },
      batchDown() {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          this.multipleSelection.forEach(e => {
            arr.push(e.actualBillingBasicId)
          });
          this.id = arr;
          this.type = 'batch';
          this.isDowning = false;
          this.showDown = true;
        } else {
          this.$message.warning("请至少选择一张下载")
        }
      },
      //下载发票
      confirmDownInvoice() {
        if (!this.isDowning) {
          this.isDowning = true;
          if (this.activeName2 == '0') {
            this.hcInfo.actualBillingBasicIds.forEach(e => {
              let data = {
                // id: this.activeName2 == '0' ? this.hcInfo.actualBillingBasicIds.toString() : this.id,
                id: [e],
                type: 2,
                wjlx: this.wjlx,
                isforce: false,
                ismerge: this.type = 'batch' ? true : false
              }
              this.confirmDownInvoice2(data)
            });
          } else {
            // let data = {
            //   id: this.id,
            //   type: 1,
            //   wjlx: this.wjlx
            // }
            // this.confirmDownInvoice2(data)
            if (this.type == 'single') {
              console.log(this.id)
              this.id.forEach(e => {
                let data = {
                  id: [e],
                  type: 2,
                  wjlx: this.wjlx,
                  isforce: false,
                  ismerge: false
                }
                this.confirmDownInvoice2(data)
              });
            } else {
              let d = {
                id: this.id,
                type: 2,
                wjlx: this.wjlx,
                isforce: false,
                ismerge: true
              }
              this.confirmDownInvoice2(d)
            }
          }
        }
      },
      confirmDownInvoice2(data) {
        if (this.type == 'single') {
          xz.IvoiceFun(data, 'DownLoadInviceFile/download').then(res => {
            if (res.status == 'ok') {
              this.isDowning = false;
              if (res.data.length > 0) {
                res.data.forEach(element => {
                  let url = this.$store.state.EMP.imgPath + element;
                  // const iframe = document.createElement('iframe');
                  // iframe.style.display = 'none';
                  // iframe.style.height = 0;
                  // iframe.src = url;
                  // document.body.appendChild(iframe);
                  // setTimeout(() => {
                  //   iframe.remove();
                  // }, 1000);
                  window.open(url, '_blank');
                  // var anchor = document.createElement("a");
                  // anchor.href = url;
                  // anchor.click();
                  // window.URL.revokeObjectURL(data);
                  this.showDown = false;
                  // if (element.data.jgzt == 1) {
                  //   let url = element.data.wjdz;
                  //   const iframe = document.createElement('iframe');
                  //   iframe.style.display = 'none';
                  //   iframe.style.height = 0;
                  //   iframe.src = url;
                  //   document.body.appendChild(iframe);
                  //   setTimeout(() => {
                  //     iframe.remove();
                  //   }, 1000);
                  //   this.showDown = false;
                  // } else {
                  //   this.showDown = false;
                  //   this.$message.error(element.data.cwxx)
                  // }
                });
              }
            } else {
              this.$message.error(res.msg)
              this.isDowning = false;
              if (res.msg.indexOf('扫脸认证已超时') > -1) {
                setTimeout(() => {
                  this.showAuthentication = true
                }, 500);
              } else if (res.msg.indexOf('登录') > -1) {
                setTimeout(() => {
                  this.getQYinfo();
                }, 500);
              } else {
                this.$message.error(res.msg)
              }
            }
          })
        } else {
          xz.DownLoadInv(data).then(res => {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = '批量下载.zip';
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isDowning = false;
              this.showDown = false;
            } catch (e) {
              this.isDowning = false;
              this.$message.error('导出异常')
            }
          })
        }
      },
      confirmSign() {
        this.needLoading = true;
        let arr = []
        this.multipleSelection.forEach(element => {
          arr.push(element.invoiceId)
        });
        const routerUrl = this.$router.resolve({
          path: "/pendInvoiceMul",
          query: {
            type: 'sign',
            id: arr.toString()
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      changeEwmlx() {
        this.QRCodeSrc = '';
        this.getQRCode();
      },
      //获取二维码
      getQRCode() {
        this.qrLoading = true;
        this.isTimeout = false;
        let data = {
          nsrsbh: this.loginForm.nsrsbh,
          areaid: this.loginForm.areaid,
          ewmlx: this.ewmlx
        }
        xz.IvoiceFun(data, 'PostThirdParty_queryAuthQrCode').then(res => {
          if (res.status == 'ok') {
            this.qrLoading = false;
            if (res.data.cwxx) {
              this.$message.error(res.data.cwxx)
            } else {
              this.QRCodeSrc = res.data.ewm;
              this.showAuthentication = true;
              this.times = 0;
              this.rzid = res.data.rzid;
              clearInterval(this.interval);
              setTimeout(() => {
                this.interval = setInterval(this.Refresh, 2000);
              }, 8000);
            }
          } else {}
        })
      },
      //获取扫码情况
      getQRStatus() {
        xz.PostThirdParty_queryAuthQrCode(this.rzid).then(res => {
          if (res.status == 'ok') {
            if (res.data.rzzt == '2') {
              this.showAuthentication = false;
              this.$message.success('认证成功');
              clearInterval(this.interval);
            } else if (res.data.rzzt == '3') {
              this.$message.success('认证超时');
              this.isTimeout = true;
              clearInterval(this.interval);
            }
          } else {}
        })
      },
      Refresh() {
        this.times++;
        this.getQRStatus();
        console.log('intervalNum', this.intervalNum)
        if (this.times == 59) {
          this.times = 0;
          this.isTimeout = true;
          clearInterval(this.interval);
          // this.$message.warning('查询超时！')
        }
      },
      confirmLogin() {
        this.$refs['loginForm'].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.IvoiceFun(this.loginForm, "PostThirdParty_asyncInit").then((res) => {
              if (res.status == "ok") {
                this.confirmLogin2()
              } else {
                this.$message.error(res.msg)
                this.isBtnLoading = false;
              }
            })
          }
        })
      },
      confirmLogin2() {
        xz.IvoiceFun(this.loginForm, "PostThirdParty_generate").then((res) => {
          if (res.status == "ok") {
            this.showLogin = false;
            this.isBtnLoading = false;
            window.open(res.data, '_blank')
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        });
      },
      PostThirdParty_subscribe() {
        let dd = [{
          nsrsbh: this.loginForm.nsrsbh, //纳税人识别号
          areaid: this.loginForm.areaid, //行政区划代码
          sqlx: 2, //授权类型1:月授权2：年授权
          sfzdxd: false, //是否自动续订
          isf: false //是否强制订阅
        }]
        xz.IvoiceFun(dd, "PostThirdParty_subscribe").then((res) => {
          if (res.status == "ok") {
            this.$router.push({
              path: this.$route.path,
              query: {
                activeName: this.activeName,
                status: 'ok'
              }
            });
            this.isBtnLoading = false;
            // this.$message.success("登录成功");
            this.showLogin = false;
            // this.getQRCode();
            this.showAuthentication = true; //认证
          } else {
            this.isBtnLoading = false;
            this.$message.error(res.msg);
            this.$router.push({
              path: this.$route.path,
              query: {
                activeName: this.activeName,
                status: 'err'
              }
            });
          }
        });
      },
      down(url) {
        var path = this.$store.state.EMP.docPath + url;
        const aTag = document.createElement("a");
        aTag.href = path;
        aTag.click();
      },
      getCustLists() {
        let d = {
          currpage: 1,
          perpage: 10000,
          strorgancode: '',
          roletype: this.roleType,
          strCustlevel: '', // 客户等级
          strProvince: '', // 省
          strCity: '', // 市
          custname: '', //客户名称
          username: '', //业务员
          depname: '', //业务部门
          strBusidepList: [], //选中的业务部门
          groupname: '', //所属集团
          strCustType: '', //客户类别
          strCustindust: '' //客户行业
        }
        xz.getCustLists(d).then(res => {
          if (res.status == 'ok') {
            this.custList = res.msg
          } else {
            this.custList = []
          }
        })
      },
      batchImportInv() {
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: "/batchImportInv",
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      changeSub(val) {
        xz.GetCorporationData(val).then((res) => {
          if (res.status == "ok") {
            if (!res.data.isonline) {
              this.showLogin = true;
              this.allQuery.nsrsbh = '';
              this.allQuery.areaid = '';
              this.allQuery.subjectOfLegalAffairs = '';
            } else {
              this.allQuery.nsrsbh = res.data.taxNum;
              this.allQuery.areaid = res.data.value;
            }
          } else {
            this.allQuery.nsrsbh = '';
            this.allQuery.areaid = '';
            this.allQuery.subjectOfLegalAffairs = '';
            this.$message.warning('获取该主体信息异常')
          }
        })
      },
      changeSub2(val) {
        if (val) {
          // let item = this.legList.find(e => e.value = val);
          xz.GetCorporationData(val).then((res) => {
            if (res.status == "ok") {
              // this.$set(this.loginForm, 'nsrsbh', res.data.taxNum);
              let encode = encodeURI(`https://emp.joball.net/invoicing?status=back&subId=${this.subjectOfLegalAffairsId}&activeName=${this.activeName}`);
              console.log(encode)
              let base64 = btoa(encode)
              this.loginForm = {
                qymc: res.data.strLegalsubName,
                nsrsbh: res.data.taxNum,
                areaid: res.data.value,
                ljlx: 'PC', //链接类型 PC、H5
                rzcghddz: base64, //认证成功回调地址(base64编码)
                ycsbhddz: base64, //异常失败回调地址(base64编码
                fhdz: base64,
                zrrsf: 14, //自然人身份1：办税员2：法定代表人3：财务负责人6：领票人8：社保经办人14：开票员
                zrrsjh: '',
                zrrmm: '',
              };
              if (this.$route.query.status == 'back' && this.$route.query.subId != undefined) {
                this.PostThirdParty_subscribe()
              }
            } else {
              this.loginForm.qymc = '';
              this.loginForm.nsrsbh = '';
              this.$message.warning('获取该主体信息异常')
            }
          })
        }
      },
      allSearch() {
        this.$refs['allQuery'].validate((valid) => {
          if (valid) {
            this.loading = true;
            xz.IvoiceFun(this.allQuery, 'PostThirdParty_queryFullInvoice').then(res => {
              if (res.status == 'ok') {
                this.allData = res.data.fplb;
                this.allTotal = res.data.total
                this.loading = false;
              } else {
                this.allData = [];
                this.loading = false;
                this.allTotal = 0;
              }
            })
          }
        })
      },
      //分页
      handleCurrentChange2(val) {
        this.allQuery.pageNo = Number(val)
        this.allSearch()
      },
      handleSizeChange2(val) {
        this.allQuery.pageNo = 1
        this.allQuery.pageSize = Number(val)
        this.allSearch()
      },
      expList() {
        let d = JSON.parse(JSON.stringify(this.listQuery));
        delete d.pagination;
        d.filename = "已开票列表导出.xlsx";
        this.isExping = true;
        xz.IvoiceEXPFun(d, 'download').then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = "已开票列表导出.xlsx";
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping = false;
            } catch (e) {
              this.isExping = false;
              this.$message.error('导出异常')
            }
          } else {
            this.isExping = false;
            this.$message.error('导出异常')
          }
        })
      }
    }
  }
</script>

<style scoped>
  .i_radio_box {
    display: -webkit-box;
    /* align-items: center; */
  }

  .i_box {
    margin-left: 30px;
  }

  .note_txt {
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
  }

  .n_txt {
    text-align: center;
    font-size: 14px;
    color: #409EFF;
  }

  .info_box {
    padding: 5px 10px 20px;
  }

  .info_tab_box {
    padding: 0 10px;
  }

  .info_item {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 5px;
  }

  .dec_box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .dec_txt {
    margin-right: 20px;
  }

  .dec_txt .txt01 {
    font-size: 14px;
    color: #000;
    font-weight: bold;
  }

  .dec_txt .txt02 {
    font-size: 14px;
    color: #409EFF;
  }

  .dec_txt .txt03 {
    font-size: 14px;
    color: #303133;
  }

  .r_act_item .com_btn {
    background-color: #19bd92;
    border-color: #19bd92;
    color: #fff;
  }

  .r_dropDownScreen {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
  }

  .r_dropDownScreen {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
  }

  .r_dropDownScreen {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
  }

  .form-item input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #ccc;
    padding-left: 14px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 10px;
  }

  .ftabs {
    background: #fff;
    width: 99%;
  }

  .expandTable {
    padding-left: 40px;
  }

  .p_employee_item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    margin-right: 3px;
  }

  .emp_txt {
    width: 120px;
    text-align: right;
    font-size: 14px;
    color: #555;
    padding: 0 10px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .emp_form_txt {
    width: 180px;
    font-size: 14px;
    color: #000;
  }

  .p_employee_form {
    display: flex;
    flex-wrap: wrap;
  }

  .emp_form_txt2 {
    font-size: 14px;
    color: #000;
  }

  .icon {
    color: #409EFF;
    font-size: 20px;
  }

  .align-items-center {
    display: flex;
    justify-content: center;
    /* align-items: center;
    height: 24px; */
  }

  .tips {
    margin: 0 0 10px 20px;
    font-size: 14px;
  }

  .billTip {
    margin-bottom: 10px;
    font-size: 14px;
  }

  .pro_down_box {
    padding-left: 29px;
  }

  .allQuery {
    padding: 0 10px 20px 10px;
  }
</style>

<style>
  .void_dialog .el-form-item {
    margin-bottom: 10px;
  }

  .re_act_box .el-button {
    padding: 4px 8px;
  }

  .page_invoicing .el-table .com_Selection.cell {
    padding: 0 25px 0 5px;
  }

  .page_invoicing .el-table .com_Selection.cell .el-checkbox__inner {
    position: relative;
  }

  .page_invoicing .el-table .com_Selection.cell:before {
    content: "全选";
    position: absolute;
    right: 2px;
    top: 1px;
  }

  .page_invoicing .screenInput .el-select .el-input__inner {
    width: 100%;
  }

  .res_dialog .el-dialog__body {
    padding: 5px 20px 20px 20px;
  }

  .divide_dialog .el-table .el-table__cell {
    padding: 0;
  }

  .note_label .el-form-item__label:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }

  .enter_dialog .el-dialog__body {
    padding: 5px 20px 10px 20px;
  }

  .page_invoicing .screenInput {
    margin: 0 0 10px 5px;
  }

  .r_act_right {
    display: flex;
    align-items: center;
  }

  .r_act_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px 20px;
  }

  .e_txt_box {
    font-size: 14px;
    color: #409eff;
    text-align: right;
  }

  .r_act_item .r_txt01 {
    font-size: 14px;
    color: #333;
    margin-right: 5px;
  }

  .r_act_right .r_txt02 {
    font-size: 14px;
    color: #409eff;
    margin-left: 8px;
  }

  .qrcode_box .r_txt03 {
    font-size: 14px;
    color: #333;
    text-align: center;
  }

  .r_act_left {
    display: flex;
    align-items: center;
  }

  .r_act_item {
    display: flex;
    align-items: center;
    margin-right: 8px;
  }

  .f_all_width {
    width: 100%;
    align-items: center;
  }

  .f_checks_box {
    flex-wrap: wrap;
    flex: 1;
  }

  .res_dialog .r_more_txt {
    margin-left: 0;
  }

  .re_down_form.el-form--inline .f_all_width .el-form-item__content {
    width: calc(100% - 100px);
    line-height: 26px;
  }

  .page_invoicing .screenInput .el-input {
    width: 200px;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .enter_dialog .re_down_form .el-form-item {
    margin-bottom: 20px;
    margin-right: 0;
  }

  .page_invoicing .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_invoicing .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_invoicing .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_invoicing .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_invoicing .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_invoicing .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .expandTable .el-table__empty-block {
    width: 1095px;
    max-width: 1095px;
    min-width: 1095px;
    padding-right: 0;
  }

  .page_invoicing .tabsColor #tab-0 {
    background: #FFFF00;
  }

  .page_invoicing .tabsColor #tab-1 {
    background: #FFFF00
  }

  .page_invoicing .el-table__expand-icon {
    display: none !important;
  }
</style>